module.exports = __webpack_public_path__ + "static/media/hidden.a5cde061.svg";